import "tippy.js/dist/tippy.css";
import "tippy.js/dist/border.css";
import "tippy.js/themes/light.css";
import "tippy.js/animations/shift-toward.css";
import tippy from "tippy.js";

export default tippy;
